<script>
import Chart from 'chart.js/auto';
export default {
  props: {
    pilot: String,
    letalo: String,
    datumOd: String,
    datumDo: String,
    primerjavaLeto: Number
  },
  emits: ['odjava'],
  data() {
    return {
      nalaganje: false,
      podatki: null,
      primerjava: null,
      tipiChart: null,
      nalogeChart: null,
      trendChart: null,
      chartInitTimeout: null,
      activeRequestToken: 0,
      isMounted: true,
      tableThemeStyle: {
        '--bs-table-bg': 'transparent',
        '--bs-table-color': '#ffffff',
        '--bs-table-border-color': 'rgba(255, 255, 255, 0.22)',
        '--bs-table-hover-color': '#ffffff',
        '--bs-table-hover-bg': 'rgba(255, 255, 255, 0.06)',
      }
    }
  },
  mounted() {
    this.PridobPodatke();
  },
  beforeUnmount() {
    this.isMounted = false;
    this.activeRequestToken += 1;
    if (this.chartInitTimeout) {
      clearTimeout(this.chartInitTimeout);
      this.chartInitTimeout = null;
    }
    this.destroyCharts();
  },
  watch: {
    pilot() {
      this.PridobPodatke();
    },
    letalo() {
      this.PridobPodatke();
    },
    datumOd() {
      this.PridobPodatke();
    },
    datumDo() {
      this.PridobPodatke();
    },
    primerjavaLeto() {
      this.PridobPodatke();
    },
  },
  methods: {
    premakniDatumVPrimerjalnoLeto(datum, leto) {
      if (!datum || !leto) return null;
      const deli = datum.split('-');
      if (deli.length !== 3) return null;
      const mesec = parseInt(deli[1], 10);
      const dan = parseInt(deli[2], 10);
      if (!mesec || !dan) return null;
      const maxDan = new Date(leto, mesec, 0).getDate();
      const novDan = Math.min(dan, maxDan);
      return `${leto}-${deli[1]}-${String(novDan).padStart(2, '0')}`;
    },
    PridobPodatke() {
      if (!this.datumOd || !this.datumDo) {
        this.podatki = null;
        this.primerjava = null;
        this.nalaganje = false;
        this.destroyCharts();
        return;
      }

      const requestToken = ++this.activeRequestToken;
      this.nalaganje = true;
      this.destroyCharts();

      // Clear any pending chart initialization
      if (this.chartInitTimeout) {
        clearTimeout(this.chartInitTimeout);
        this.chartInitTimeout = null;
      }

      const podatki = new URLSearchParams();
      podatki.append('pilot', this.pilot);
      if (this.letalo) {
        podatki.append('letalo', this.letalo);
      }
      podatki.append('datum_od', this.datumOd);
      podatki.append('datum_do', this.datumDo);

      axios.post('./api/porocila/pilot/', podatki, {withCredentials: true})
          .then((response) => {
            if (!this.isMounted || requestToken !== this.activeRequestToken) return;

            this.podatki = response.data.podatki;
            this.nalaganje = false;

            // Debounce chart initialization to prevent rapid recreation
            this.chartInitTimeout = setTimeout(() => {
              this.$nextTick(() => {
                if (!this.isMounted || requestToken !== this.activeRequestToken || !this.podatki) return;
                if (this.podatki) {
                  this.initCharts();
                }
              });
            }, 100);

            if (this.primerjavaLeto) {
              this.PridobPrimerjavo(requestToken);
            } else {
              this.primerjava = null;
            }
          })
          .catch((napaka) => {
            if (!this.isMounted || requestToken !== this.activeRequestToken) return;
            if (napaka.response?.status === 401) {
              this.$router.push('/Logout');
            }
            this.podatki = null;
            this.destroyCharts();
            this.nalaganje = false;
          });
    },
    PridobPrimerjavo(requestToken = this.activeRequestToken) {
      const primerjavaDatumOd = this.premakniDatumVPrimerjalnoLeto(this.datumOd, this.primerjavaLeto);
      const primerjavaDatumDo = this.premakniDatumVPrimerjalnoLeto(this.datumDo, this.primerjavaLeto);
      if (!primerjavaDatumOd || !primerjavaDatumDo) {
        this.primerjava = null;
        return;
      }

      const podatki = new URLSearchParams();
      podatki.append('pilot', this.pilot);
      if (this.letalo) {
        podatki.append('letalo', this.letalo);
      }
      podatki.append('datum_od', primerjavaDatumOd);
      podatki.append('datum_do', primerjavaDatumDo);

      axios.post('./api/porocila/pilot/', podatki, {withCredentials: true})
          .then((response) => {
            if (!this.isMounted || requestToken !== this.activeRequestToken) return;
            this.primerjava = response.data.podatki;
          })
          .catch(() => {
            if (!this.isMounted || requestToken !== this.activeRequestToken) return;
            this.primerjava = null;
          });
    },
    destroyCharts() {
      if (this.chartInitTimeout) {
        clearTimeout(this.chartInitTimeout);
        this.chartInitTimeout = null;
      }

      try {
        if (this.tipiChart) {
          this.tipiChart.stop();
          this.tipiChart.destroy();
          this.tipiChart = null;
        }
      } catch (e) {
        this.tipiChart = null;
      }

      try {
        if (this.nalogeChart) {
          this.nalogeChart.stop();
          this.nalogeChart.destroy();
          this.nalogeChart = null;
        }
      } catch (e) {
        this.nalogeChart = null;
      }

      try {
        if (this.trendChart) {
          this.trendChart.stop();
          this.trendChart.destroy();
          this.trendChart = null;
        }
      } catch (e) {
        this.trendChart = null;
      }
    },
    initCharts() {
      if (!Chart || !this.podatki || !this.isMounted || this.nalaganje) return;
      this.destroyCharts();

      const tipiData = Array.isArray(this.podatki.tipi_leta) ? this.podatki.tipi_leta : [];
      const nalogeData = Array.isArray(this.podatki.naloge) ? this.podatki.naloge : [];

      const isCanvasValid = (canvas) => {
        if (!canvas || !canvas.getContext || !canvas.ownerDocument || !canvas.isConnected || !document.body.contains(canvas)) {
          return false;
        }
        const context2d = canvas.getContext('2d');
        return !!(context2d && typeof context2d.save === 'function' && typeof context2d.restore === 'function');
      };

      const createChartSafe = (canvas, config) => {
        if (!isCanvasValid(canvas)) return null;
        const context2d = canvas.getContext('2d');
        if (!context2d || typeof context2d.save !== 'function') return null;
        try {
          if (Chart.getChart) {
            const existingChart = Chart.getChart(canvas);
            if (existingChart) {
              try {
                existingChart.stop();
                existingChart.destroy();
              } catch (e) {
                // ignore stale instance cleanup issues
              }
            }
          }
          const chartConfig = {
            ...config,
            options: {
              animation: false,
              ...(config.options || {})
            }
          };
          return new Chart(context2d, chartConfig);
        } catch (e) {
          return null;
        }
      };

      if (tipiData.length > 0 && isCanvasValid(this.$refs.tipiChartCanvas)) {
        const tipiLabels = tipiData.map((item) => item.naziv);
        const tipiValues = tipiData.map((item) => Number(item.stevilo) || 0);

        this.tipiChart = createChartSafe(this.$refs.tipiChartCanvas, {
          type: 'doughnut',
          data: {
            labels: tipiLabels,
            datasets: [{
              data: tipiValues,
              backgroundColor: ['#60a5fa', '#34d399', '#fbbf24', '#f472b6', '#a78bfa', '#38bdf8'],
              borderWidth: 1,
              borderColor: 'rgba(255, 255, 255, 0.2)'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'bottom',
                labels: {
                  color: '#ffffff',
                  boxWidth: 12
                }
              }
            }
          }
        });
      }

      if (nalogeData.length > 0 && isCanvasValid(this.$refs.nalogeChartCanvas)) {
        const nalogeLabels = nalogeData.map((item) => item.naziv);
        const nalogeValues = nalogeData.map((item) => Number(item.stevilo) || 0);

        this.nalogeChart = createChartSafe(this.$refs.nalogeChartCanvas, {
          type: 'bar',
          data: {
            labels: nalogeLabels,
            datasets: [{
              label: 'Število letov',
              data: nalogeValues,
              backgroundColor: 'rgba(96, 165, 250, 0.8)',
              borderColor: 'rgba(147, 197, 253, 1)',
              borderWidth: 1,
              borderRadius: 6
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              }
            },
            scales: {
              x: {
                ticks: {color: '#ffffff'},
                grid: {color: 'rgba(255, 255, 255, 0.12)'}
              },
              y: {
                beginAtZero: true,
                ticks: {color: '#ffffff', precision: 0},
                grid: {color: 'rgba(255, 255, 255, 0.12)'}
              }
            }
          }
        });
      }

      const trendData = Array.isArray(this.podatki.mesecni_trend) ? this.podatki.mesecni_trend : [];
      if (trendData.length > 0 && isCanvasValid(this.$refs.trendChartCanvas)) {
        const labels = trendData.map((item) => item.mesec_naziv || item.mesec);
        const values = trendData.map((item) => {
          const cas = (item.cas || '00:00').split(':').map(Number);
          return ((cas[0] || 0) * 60) + (cas[1] || 0);
        });

        this.trendChart = createChartSafe(this.$refs.trendChartCanvas, {
          type: 'line',
          data: {
            labels,
            datasets: [{
              label: 'Ure letenja (minute)',
              data: values,
              borderColor: 'rgba(52, 211, 153, 1)',
              backgroundColor: 'rgba(52, 211, 153, 0.22)',
              fill: true,
              tension: 0.3,
              pointRadius: 3,
              pointBackgroundColor: '#34d399'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                labels: {color: '#ffffff'}
              }
            },
            scales: {
              x: {
                ticks: {color: '#ffffff'},
                grid: {color: 'rgba(255, 255, 255, 0.12)'}
              },
              y: {
                beginAtZero: true,
                ticks: {color: '#ffffff'},
                grid: {color: 'rgba(255, 255, 255, 0.12)'}
              }
            }
          }
        });
      }
    },
    formatNumber(num) {
      return num ? num.toLocaleString('sl-SI') : '0';
    }
  }
}
</script>
<template>
  <div>
    <div v-if="nalaganje" class="text-center p-5 text-white">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Nalaganje...</span>
      </div>
    </div>

    <div v-else-if="podatki" class="row g-4">
      <div class="col-12" v-if="letalo">
        <div class="alert alert-info mb-0 d-flex align-items-center gap-2">
          <i class="fas fa-filter"></i>
          <span>Prikaz je filtriran na letalo: <strong>{{ letalo }}</strong>.</span>
        </div>
      </div>
      <!-- Skupne ure -->
      <div class="col-md-4">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="card-subtitle mb-0 text-white-50">Skupne ure letenja</h6>
              <i class="far fa-clock fs-5"></i>
            </div>
            <h3 class="card-title mb-0">{{ podatki.skupno_cas }}</h3>
            <small class="text-white-50">{{ formatNumber(podatki.skupno_stevilo) }} letov</small>
            <br>
            <small v-if="primerjava" class="text-white-50"><i class="fas fa-exchange-alt"></i> vs. {{ primerjava.skupno_cas }} ({{ primerjavaLeto }})</small>
          </div>
        </div>
      </div>

      <!-- Motorni let -->
      <div class="col-md-4">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="card-subtitle mb-0 text-white-50">Motorni let</h6>
              <i class="fas fa-plane fs5"></i>
            </div>
            <h3 class="card-title mb-0">{{ podatki.motorni_cas }}</h3>
            <small class="text-white-50">{{ formatNumber(podatki.motorni_stevilo) }} letov</small>
            <br>
            <small v-if="primerjava" class="text-white-50"><i class="fas fa-exchange-alt"></i> vs. {{ primerjava.motorni_cas }} ({{ primerjavaLeto }})</small>
          </div>
        </div>
      </div>

      <!-- Jadralni let -->
      <div class="col-md-4">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="card-subtitle mb-0 text-white-50">Jadralni let</h6>
              <i class="far fa-paper-plane fs-5"></i>
            </div>
            <h3 class="card-title mb-0">{{ podatki.jadralni_cas }}</h3>
            <small class="text-white-50">{{ formatNumber(podatki.jadralni_stevilo) }} letov</small>
            <br>
            <small v-if="primerjava" class="text-white-50"><i class="fas fa-exchange-alt"></i> vs. {{ primerjava.jadralni_cas }} ({{ primerjavaLeto }})</small>
          </div>
        </div>
      </div>

      <!-- Graf tipov leta -->
      <div class="col-md-6">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-header d-flex align-items-center gap-2 border-0">
            <i class="fas fa-chart-pie"></i>
            <h5 class="mb-0">Tipi leta - graf</h5>
          </div>
          <div class="card-body" style="min-height: 280px;">
            <canvas ref="tipiChartCanvas"></canvas>
          </div>
        </div>
      </div>

      <!-- Graf nalog -->
      <div class="col-md-6">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-header d-flex align-items-center gap-2 border-0">
            <i class="fas fa-chart-bar"></i>
            <h5 class="mb-0">Naloge - graf</h5>
          </div>
          <div class="card-body" style="min-height: 280px;">
            <canvas ref="nalogeChartCanvas"></canvas>
          </div>
        </div>
      </div>

      <!-- Mesečni trend (letni prikaz) -->
      <div class="col-12" v-if="podatki.mesecni_trend && podatki.mesecni_trend.length">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4">
          <div class="card-header d-flex align-items-center gap-2 border-0">
            <i class="fas fa-chart-line"></i>
            <h5 class="mb-0">Mesečni trend ({{ datumOd }} - {{ datumDo }})</h5>
          </div>
          <div class="card-body" style="min-height: 280px;">
            <canvas ref="trendChartCanvas"></canvas>
          </div>
        </div>
      </div>

      <!-- Razdelitev po tipih leta -->
      <div class="col-lg-6">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-header border-0 d-flex align-items-center gap-2">
            <i class="fas fa-border-all"></i>
            <h5 class="mb-0">Razdelitev po tipih leta</h5>
          </div>
          <div class="card-body">
            <table class="table table-sm mb-0 align-middle" :style="tableThemeStyle">
              <thead>
              <tr>
                <th class="text-white-50">Tip leta</th>
                <th class="text-end">Ure</th>
                <th class="text-end">Število</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="tip in podatki.tipi_leta" :key="tip.naziv">
                <td>{{ tip.naziv }}</td>
                <td class="text-end">{{ tip.cas }}</td>
                <td class="text-end">{{ formatNumber(tip.stevilo) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Razdelitev po nalogah -->
      <div class="col-lg-6">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4 h-100">
          <div class="card-header border-0 d-flex align-items-center gap-2">
            <i class="fas fa-list"></i>
            <h5 class="mb-0">Razdelitev po nalogah</h5>
          </div>
          <div class="card-body">
            <table class="table table-sm mb-0 align-middle" :style="tableThemeStyle">
              <thead>
              <tr>
                <th class="text-white-50">Naloga</th>
                <th class="text-end">Ure</th>
                <th class="text-end">Število</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="naloga in podatki.naloge" :key="naloga.naziv">
                <td>{{ naloga.naziv }}</td>
                <td class="text-end">{{ naloga.cas }}</td>
                <td class="text-end">{{ formatNumber(naloga.stevilo) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Letala, s katerimi je letel -->
      <div class="col-12 mb-4">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4">
          <div class="card-header border-0 d-flex align-items-center gap-2">
            <i class="fas fa-plane"></i>
            <h5 class="mb-0">Uporabljena letala</h5>
          </div>
          <div class="card-body">
            <table class="table table-sm mb-0 align-middle" :style="tableThemeStyle">
              <thead>
              <tr>
                <th class="text-white-50">Registracija</th>
                <th class="text-white-50">Tip</th>
                <th class="text-end">Ure</th>
                <th class="text-end">Število letov</th>
                <th class="text-end">Povprečje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="letalo in podatki.letala" :key="letalo.registracija">
                <td>{{ letalo.registracija }}</td>
                <td>{{ letalo.tip }}</td>
                <td class="text-end">{{ letalo.cas }}</td>
                <td class="text-end">{{ formatNumber(letalo.stevilo) }}</td>
                <td class="text-end">{{ letalo.povprecje }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Kot inštruktor -->
      <div class="col-12" v-if="podatki.kot_instruktor && podatki.kot_instruktor.cas !== '00:00'">
        <div class="card bg-cards text-white border-0 shadow-sm rounded-4">
          <div class="card-header border-0">
            <h5 class="mb-0"><i class="fas fa-graduation-cap"></i> Kot inštruktor</h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-3">
                <div class="border-start border-warning border-3 ps-3">
                  <small class="text-white-50 d-block">Skupne ure</small>
                  <strong class="fs-4">{{ podatki.kot_instruktor.cas }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border-start border-warning border-3 ps-3">
                  <small class="text-white-50 d-block">Število šolanj</small>
                  <strong class="fs-4">{{ formatNumber(podatki.kot_instruktor.stevilo) }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border-start border-warning border-3 ps-3">
                  <small class="text-white-50 d-block">Različnih učencev</small>
                  <strong class="fs-4">{{ formatNumber(podatki.kot_instruktor.st_ucencev) }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border-start border-warning border-3 ps-3">
                  <small class="text-white-50 d-block">Povprečno ur/šolanje</small>
                  <strong class="fs-4">{{ podatki.kot_instruktor.povprecje }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="alert alert-warning">
      <i class="fas fa-exclamation-triangle"></i> Ni podatkov za izbranega pilota in obdobje.
    </div>
  </div>
</template>